<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: drives.vue
  - Created by: ChanYing
  - Create Date: 2023-05-11 17:11
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" id="drives">
    <path
        d="M16.25 11.25H3.75C3.40482 11.25 3.125 11.5298 3.125 11.875V15.625C3.125 15.9702 3.40482 16.25 3.75 16.25H16.25C16.5952 16.25 16.875 15.9702 16.875 15.625V11.875C16.875 11.5298 16.5952 11.25 16.25 11.25Z"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M16.25 3.75H3.75C3.40482 3.75 3.125 4.02982 3.125 4.375V8.125C3.125 8.47018 3.40482 8.75 3.75 8.75H16.25C16.5952 8.75 16.875 8.47018 16.875 8.125V4.375C16.875 4.02982 16.5952 3.75 16.25 3.75Z"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M14.0625 7.1875C14.5803 7.1875 15 6.76777 15 6.25C15 5.73223 14.5803 5.3125 14.0625 5.3125C13.5447 5.3125 13.125 5.73223 13.125 6.25C13.125 6.76777 13.5447 7.1875 14.0625 7.1875Z"
        :stroke="strokeColor" fill="none"/>
    <path
        d="M14.0625 15.9375C14.5803 15.9375 15 15.5178 15 15C15 14.4822 14.5803 14.0625 14.0625 14.0625C13.5447 14.0625 13.125 14.4822 13.125 15C13.125 15.5178 13.5447 15.9375 14.0625 15.9375Z"
        :stroke="strokeColor" fill="none"/>
  </svg>
</template>

<script>
export default {
  name: "drives-svg",
  props: {
    strokeColor: {
      type: String,
      default: "var(--body-aux-1)"
    }
  },
}
</script>

